import { render, staticRenderFns } from "./BillReport.vue?vue&type=template&id=3389ea80&scoped=true"
import script from "./BillReport.vue?vue&type=script&lang=js"
export * from "./BillReport.vue?vue&type=script&lang=js"
import style0 from "./BillReport.vue?vue&type=style&index=0&id=3389ea80&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3389ea80",
  null
  
)

export default component.exports